import { render, staticRenderFns } from "./EmploymentAllowancesImportFailed.vue?vue&type=template&id=ff0de284"
import script from "./EmploymentAllowancesImportFailed.vue?vue&type=script&lang=js"
export * from "./EmploymentAllowancesImportFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports